import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-contacts',
  templateUrl: './contacts.component.html'
})
export class ContactsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
